/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Guide_Intro_P2Inputs */

const es_marketplace_seo_galicia_guide_intro_p2 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Intro_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanto veleros como lanchas a motor permiten explorar calas poco accesibles por tierra y disfrutar del mar con armadores que conocen cada ría.`)
};

const gl_marketplace_seo_galicia_guide_intro_p2 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Intro_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanto veleiros como lanchas a motor permiten explorar calas pouco accesibles por terra e gozar do mar con armadores que coñecen cada ría.`)
};

const en_marketplace_seo_galicia_guide_intro_p2 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Intro_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sailboats and motorboats let you reach coves inaccessible by land, with owners who know every ria.`)
};

/**
* | output |
* | --- |
* | "Sailboats and motorboats let you reach coves inaccessible by land, with owners who know every ria." |
*
* @param {Marketplace_Seo_Galicia_Guide_Intro_P2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_guide_intro_p2 = /** @type {((inputs?: Marketplace_Seo_Galicia_Guide_Intro_P2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Guide_Intro_P2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_guide_intro_p2(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_guide_intro_p2(inputs)
	return es_marketplace_seo_galicia_guide_intro_p2(inputs)
});